import './src/styles/global.css'

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) return false
  window.scrollTo(0, 0)
  return false
}
